import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api, euro } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { CheckCircle2, Clock, XCircle, Smartphone, Loader2 } from "lucide-react";

export default function PublicActivation() {
  const { rid } = useParams();
  const [state, setState] = useState({ loading: true, error: null, data: null });

  useEffect(() => {
    const t = new URLSearchParams(window.location.search).get("t") || "";
    api.get(`/italiamobile/public/activation/${rid}`, { params: { t } })
      .then((r) => setState({ loading: false, error: null, data: r.data }))
      .catch((e) => setState({ loading: false, error: e.response?.data?.detail || "Link non valido", data: null }));
  }, [rid]);

  const { loading, error, data } = state;
  const activated = data?.status === "completata" && data?.activated;

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4 py-10" data-testid="public-activation-page">
      <Card className="w-full max-w-md p-8 text-center space-y-5 glow-border">
        <div className="w-14 h-14 mx-auto rounded-2xl bg-primary/15 text-primary flex items-center justify-center">
          <Smartphone className="w-7 h-7" />
        </div>
        <h1 className="font-head text-2xl font-semibold">Attivazione Italia Mobile</h1>

        {loading && <p className="text-muted-foreground flex items-center justify-center gap-2" data-testid="pa-loading"><Loader2 className="w-4 h-4 animate-spin" /> Caricamento…</p>}

        {!loading && error && (
          <div className="space-y-2" data-testid="pa-error">
            <XCircle className="w-10 h-10 text-red-500 mx-auto" />
            <p className="text-sm text-muted-foreground">{error}</p>
          </div>
        )}

        {!loading && data && (
          <div className="space-y-4" data-testid="pa-content">
            <p className="text-muted-foreground">Ciao <span className="font-medium text-foreground">{data.nome || "cliente"}</span>, ecco lo stato della tua richiesta.</p>
            <div className="rounded-xl border border-border p-4 text-left space-y-1.5 text-sm">
              <div className="flex justify-between"><span className="text-muted-foreground">Piano</span><span className="font-medium">{data.piano || "—"}</span></div>
              <div className="flex justify-between"><span className="text-muted-foreground">Tipo</span><span className="font-medium">{data.is_migration ? "Portabilità (MNP)" : "Nuovo numero"}</span></div>
              <div className="flex justify-between"><span className="text-muted-foreground">Costo attivazione</span><span className="font-medium">{euro(data.activation_cost)}</span></div>
            </div>
            {activated ? (
              <div className="rounded-xl border border-teal-500/40 bg-teal-500/5 p-4 flex items-center gap-2 text-teal-600 text-sm" data-testid="pa-activated">
                <CheckCircle2 className="w-5 h-5" /> Servizio attivo! Buona navigazione.
              </div>
            ) : (
              <div className="rounded-xl border border-amber-500/40 bg-amber-500/5 p-4 flex items-center gap-2 text-amber-600 text-sm" data-testid="pa-in-progress">
                <Clock className="w-5 h-5" /> La tua SIM è in fase di attivazione. Riceverai conferma a breve.
              </div>
            )}
            <p className="text-xs text-muted-foreground">Per assistenza contatta il tuo rivenditore di fiducia.</p>
          </div>
        )}
      </Card>
    </div>
  );
}
